'use strict'

# isMobile = false
# if /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
#   isMobile = true
# windowWidth = $(window).width()
# if windowWidth < 768
#   isMobile = true

### jshint undef: true, unused: false ###

jsUcfirst = (string) ->
  string.charAt(0).toUpperCase() + string.slice(1)

setCookie = (cname, cvalue, exdays) ->
  d = new Date()
  d.setTime(d.getTime() + (exdays*24*60*60*1000))
  expires = 'expires='+ d.toUTCString()
  document.cookie = cname + "=" + cvalue + "; " + expires + ";path=/"

selectByChoice = (choice, useCookie) ->
  $('.current-season').find('.ticket-finder-by-' + choice).show()
  $('.current-season > div').not('.ticket-finder-by-' + choice).hide()
  $('.past-season').find('.ticket-finder-by-' + choice).show()
  $('.past-season > div').not('.ticket-finder-by-' + choice).hide()

  if useCookie is true
    myCookie = 'ticket_finder_option=by' + jsUcfirst(choice)    
    document.cookie = myCookie
    setCookie('ticket_finder_option', 'by' + jsUcfirst(choice), 365)


selectByCity = ->
  selectByChoice('city', true)
  return

selectByRegion = ->
  selectByChoice('region', true)
  return

selectBySchedule = ->
  selectByChoice('schedule', true)
  # console.log 'why is schedule now?'
  return

selectByDistance = ->
  selectByChoice('distance', false)
  return


getCookie = (cname) ->
  name = cname + '='
  ca = document.cookie.split(';')
  for x in ca
    c = x
    while c.charAt(0) == ' '
      c = c.substring(1)
    if c.indexOf(name) == 0
      return c.substring(name.length, c.length)
  return ''


TicketFinder =
  init: ->
    @loadByCookie()
    # @AutoChecked()
    # triggerElem = $('.ticket-finder-sub-col, .ticket-finder-schedule-col').find('.ticket-finder-city')
    # @showTicketBox(triggerElem)
    triggerElem = $('.ticket-finder-sub-col, .ticket-finder-schedule-col').find('.js-trigger-popup')

    @showTicketBox(triggerElem)
    # @showNotifiedBox()

  _showToolTip: (triggerElem, cityBox) ->
    for x in triggerElem
      elem = x
      eachAction = ->
        columnClass = $(elem).parents('.sort-layout-col')
        tooltipInRight = columnClass.hasClass('left-side')
        orientation = if tooltipInRight then 'right' else 'left'
        offsetX_size = if orientation == 'left' then 20 else 0
        eid = $(elem).attr('id')
        $(elem).tooltipster
          contentAsHTML: true
          theme: 'tooltipster-shadow'
          updateAnimation: false
          animation: 'fade'
          delay: 200
          touchDevices: false
          onlyOne: true
          position: orientation
          # side: orientation
          offsetX: offsetX_size
          interactive: true
          # autoClose: false
          
          content: '<div class="load-wrapper"><div class="load-spinner shenyun-glyphs-spinner shenyun-glyphs"></div></div>'
          functionBefore: (origin, continueTooltip) ->
            continueTooltip()
            if origin.data('ajax') != 'cached'
              $.ajax
                type: 'GET'
                url: cityBox + '/eid/' + eid
                success: (data) ->
                  origin.tooltipster('content', data).data 'ajax', 'cached'
          # functionBefore: (instance, helper) ->
          #   # continueTooltip()
          #   $origin = $(helper.origin)
          #   if $origin.data('loaded') != true
          #     $.get(cityBox + '/eid/' + eid, (data) ->
          #       instance.content(data)
          #       $origin.data('loaded', true)
          #     )


      eachAction()



  showTicketBox: (triggerElem) ->
    isMobileW = false

    testWidth = ->
      windowWidth = $(window).width()
      if windowWidth < 768
        isMobileW = true
      else
        isMobileW = false

    testWidth()
    
    # windowWidth = $(window).width()
    # if windowWidth < 768
    #   isMobile = true
    #   console.log windowWidth
    # if /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    #   isMobile = true

    # triggerElem = $('.ticket-finder-sub-col, .ticket-finder-schedule-col').find('.ticket-finder-city')
    cityBox = '/tickets/ajax-get-event'

    # TicketFinder._showToolTip triggerElem, cityBox


    if not isMobileW
      if !triggerElem.hasClass 'tooltipstered'
        TicketFinder._showToolTip(triggerElem, cityBox)
    else
      if triggerElem.hasClass 'tooltipstered'
        triggerElem.tooltipster 'destroy'

      # TicketFinder._showToolTip(triggerElem, cityBox)
      # $(triggerElem).tooltipster('hide')
 
  loadByCookie: ->
    # x = getCookie('ticket_finder_option')

    x = getCookie('ticket_finder_option')
    # setCookie('ticket_finder_option', x, 365)
    
    switch x
      when 'byCity'
        selectByCity()
        $('input[name=\'ticket-finder-view-choice\'][value=\'city\']').attr 'checked', 'checked'
      when 'byRegion'
        selectByRegion()
        $('input[name=\'ticket-finder-view-choice\'][value=\'region\']').attr 'checked', 'checked'
      when 'bySchedule'
        selectBySchedule()
        $('input[name=\'ticket-finder-view-choice\'][value=\'schedule\']').attr 'checked', 'checked'
      else
        selectByRegion()
        #default to region
        $('input[name=\'ticket-finder-view-choice\'][value=\'region\']').attr 'checked', 'checked'

$(window).resize ->
  TicketFinder.init()



TicketFinder.init()



